function Seksscan(el) {
    this.el = el;

    this.startEl = this.el.querySelector('.jsStart');
    this.questionsEl = this.el.querySelector('.jsQuestions');
    this.resultEl = this.el.querySelector('.jsResult');

    this.progressEl = this.el.querySelector('.jsProgress');
    this.paginationBtnEls = this.el.querySelector('.jsPaginationBtns');

    this.questionEls = this.el.querySelectorAll('.jsQuestion');
    this.currentQuestionIndex = 0;
    this.questionCount = this.questionEls.length;
    this.defaultQuestionCount = 0;
    this.questionAnswers = [];
    this.answerBtnwrapper = this.el.querySelector('.jsAnswerBtns');
    this.multiAnswerBtnWrapper = this.el.querySelector('.jsAnswerBtnsMulti');
    this.percentageEl = this.el.querySelector('.jsResult .jsPercentage');

    this.formEl = this.el.querySelector('.jsResultForm');
    this.formEmailInput = this.formEl.querySelector('input[type="email"]');
    this.firstNameInput = this.el.querySelector('.jsFirstName');

    this.currentPage = 'start';

    this.resetQuestionAnswers();

    window.dataLayer = window.dataLayer || [];

    this.updateBtnVisibility();
    this.setDefaultQuestionCount();

    // Check if we have existing results
    let existingResults = localStorage.getItem('rutgers_seksscan_temp_results');

    if (existingResults) {
        existingResults = JSON.parse(existingResults);

        if (existingResults.length && existingResults.length === this.questionCount) {
            this.startEl.classList.add('has-results');
            this.questionAnswers = existingResults;
        }
        else {
            this.clearLocalStorage();
        }
    }


    // Start the scan
    this.startEl.addEventListener('click', (e) => {
        const isNew = e.target.classList.contains('jsStartNew');
        const isContinue = e.target.classList.contains('jsStartContinue');
        if (!isNew && !isContinue) return;

        if (isNew) {
            this.clearLocalStorage();
            this.resetQuestionAnswers();
            this.currentQuestionIndex = 0;

            this.currentPage = 'questions';

            this.startEl.classList.remove('active');
            this.questionsEl.classList.add('active');
            this.resultEl.classList.remove('active');
            this.showActiveQuestion();

            window.dataLayer.push({ event: 'seksscan_start', method: 'new_scan' });
        }
        else if (isContinue) {
            this.currentPage = 'questions';

            // Go the the first question that has no answer (or the last)
            this.currentQuestionIndex = this.questionAnswers.indexOf('') > -1 ? this.questionAnswers.indexOf('') : this.questionCount - 1;
            this.showActiveQuestion();

            this.startEl.classList.remove('active');
            this.questionsEl.classList.add('active');
            this.resultEl.classList.remove('active');

            window.dataLayer.push({ event: 'seksscan_start', method: 'continue_existing_scan' });
        }
    });

    this.paginationBtnEls.addEventListener('click', (e) => {
        if (e.target.classList.contains('jsPrev')) {
            window.dataLayer.push({ event: 'seksscan_skip_question', questionTitle: this.getCurrentQuestionTitle(), direction: 'previous' });
            this.prevQuestion();
        }
        else if (e.target.classList.contains('jsNext')) {
            if (!this.isNextQuestionAllowed()) return;

            window.dataLayer.push({ event: 'seksscan_skip_question', questionTitle: this.getCurrentQuestionTitle(), direction: 'next' });
            this.nextQuestion();
        }
    });

    this.answerBtnwrapper.addEventListener('click', (e) => {
        if (e.target.classList.contains('jsAnswerBtn')) {
            if (e.target.classList.contains('jsYes')) {
                this.questionAnswers[this.currentQuestionIndex] = 'yes';
                window.dataLayer.push({ event: 'seksscan_answer_yes', questionTitle: this.getCurrentQuestionTitle() });
            }
            else if (e.target.classList.contains('jsNo')) {
                this.questionAnswers[this.currentQuestionIndex] = 'no';
                window.dataLayer.push({ event: 'seksscan_answer_no', questionTitle: this.getCurrentQuestionTitle() });
            }
            else if (e.target.classList.contains('jsDontKnow')) {
                this.questionAnswers[this.currentQuestionIndex] = 'idk';
                window.dataLayer.push({ event: 'seksscan_answer_idk', questionTitle: this.getCurrentQuestionTitle() });
            }

            this.updateLocalStorage();
            this.nextQuestion();
        }
    });

    this.multiAnswerBtnWrapper.addEventListener('click', (e) => {
        if (!e.target.classList.contains('jsContinue')) return;

        const checkboxAnswers = this.questionEls[this.currentQuestionIndex].querySelectorAll('input[type="checkbox"]:checked');
        const selectedAnswers = [...checkboxAnswers].map((el) => el.value);

        const otherInputEl = this.questionEls[this.currentQuestionIndex].querySelector('input[type="text"]');
        const otherValue = otherInputEl ? otherInputEl.value.trim() : '';

        if (otherValue !== '') selectedAnswers.push('Anders: ' + otherValue);

        if (!selectedAnswers.length) {
            alert('Kies één of meerdere antwoorden om door te gaan.');
            return;
        }

        this.questionAnswers[this.currentQuestionIndex] = selectedAnswers;
        window.dataLayer.push({ event: 'seksscan_answer_multi', questionTitle: this.getCurrentQuestionTitle(), answers: selectedAnswers.join(', ') });

        this.updateLocalStorage();
        this.nextQuestion();
    });

    this.formEl.addEventListener('submit', (e) => {
        e.preventDefault();
        if (this.currentPage !== 'result') return;

        const email = this.formEmailInput.value.trim();
        const firstName = this.firstNameInput.value.trim();

        // Check if whe have an email address
        if (email === '') {
            alert('Voer eerst een geldig e-mailadres in om door te gaan');
            return;
        }

        // Check if the email address seems valid
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            alert('Voer eerst een geldig e-mailadres in om door te gaan');
            return;
        }

        this.formEl.classList.add('loading');

        // Send the request
        se_postRequest(se_ajax.ajaxurl, { action: 'generate_seksscan_pdf', scores: JSON.stringify(this.questionAnswers), email, firstName }, response => {
            this.formEl.classList.remove('loading');
            response = (response || '').trim();

            if (response === 'invalid-email') {
                alert('Voer eerst een geldig e-mailadres in om door te gaan');
                return;
            }
            else if (response === 'success') {
                this.formEl.classList.add('success');
                window.dataLayer.push({ event: 'seksscan_result_email_send' });
                this.clearLocalStorage();
                return;
            }

            alert('Er ging iets fout bij het versturen van de resultaten. Probeer het nogmaals of neem contact met ons op.');
        }, _ => {
            this.formEl.classList.remove('loading');
            console.error('Something went wrong while sending the request. Please try again or contact us.');
            alert('Er ging iets fout bij het versturen van de resultaten. Probeer het nogmaals of neem contact met ons op.');
        });
    });
}

Seksscan.prototype.setDefaultQuestionCount = function () {
    let count = 0;

    [...this.questionEls].map((el) => { if (el.dataset.questionType === 'default') count++; });
    this.defaultQuestionCount = count;
};

Seksscan.prototype.getCurrentQuestionTitle = function () {
    return this.questionEls[this.currentQuestionIndex].querySelector('.jsQuestionTitle').innerHTML;
};

Seksscan.prototype.resetQuestionAnswers = function () {
    this.questionAnswers = [...this.questionEls].map(() => { return '' })
};

Seksscan.prototype.updateLocalStorage = function () {
    localStorage.setItem('rutgers_seksscan_temp_results', JSON.stringify(this.questionAnswers));
};

Seksscan.prototype.clearLocalStorage = function () {
    localStorage.removeItem('rutgers_seksscan_temp_results');
};

Seksscan.prototype.updateProgress = function () {
    this.progressEl.innerHTML = `${this.currentQuestionIndex + 1}/${this.questionCount}`;
};

Seksscan.prototype.updateBtnVisibility = function () {
    // Show/hide the previous button
    if (this.currentQuestionIndex === 0) this.paginationBtnEls.querySelector('.jsPrev').classList.add('hidden');
    else this.paginationBtnEls.querySelector('.jsPrev').classList.remove('hidden');

    // Show/hide the next button
    if (this.questionAnswers[this.currentQuestionIndex] === '') this.paginationBtnEls.querySelector('.jsNext').classList.add('hidden');
    else this.paginationBtnEls.querySelector('.jsNext').classList.remove('hidden');

    // Show/hide the answer buttons
    if (this.questionEls[this.currentQuestionIndex].dataset.questionType === 'default') {
        this.answerBtnwrapper.classList.remove('hidden');
        this.multiAnswerBtnWrapper.classList.add('hidden');
    }
    else {
        this.answerBtnwrapper.classList.add('hidden');
        this.multiAnswerBtnWrapper.classList.remove('hidden');
    }
};

Seksscan.prototype.isNextQuestionAllowed = function () {
    return this.questionAnswers[this.currentQuestionIndex] !== '';
};

Seksscan.prototype.nextQuestion = function () {
    this.currentQuestionIndex++;

    if (this.currentQuestionIndex > this.questionCount - 1) {
        this.currentQuestionIndex = this.questionCount - 1;

        this.showResult();
        return;
    }

    this.showActiveQuestion();
};

Seksscan.prototype.showActiveQuestion = function () {
    [...this.questionEls].map((el, index) => {
        if (index === this.currentQuestionIndex) {
            if (typeof this.questionAnswers[this.currentQuestionIndex] !== 'string') {
                // Check the checkboxes
                this.questionEls[this.currentQuestionIndex].querySelectorAll('input[type="checkbox"]').forEach((checkboxEl) => {
                    checkboxEl.checked = this.questionAnswers[this.currentQuestionIndex].includes(checkboxEl.value);
                });

                // Set the input value
                const inputEl = this.questionEls[this.currentQuestionIndex].querySelector('input[type="text"]');
                if (inputEl) {
                    const otherValue = this.questionAnswers[this.currentQuestionIndex].find((answer) => answer.includes('Anders: '));
                    inputEl.value = otherValue ? otherValue.replace('Anders: ', '') : '';
                }
            }
            else {
                // Check the answer buttons
                this.answerBtnwrapper.querySelectorAll('.jsAnswerBtn').forEach((btn) => {
                    if (this.questionAnswers[this.currentQuestionIndex] === btn.dataset.answer) btn.classList.add('checked');
                    else btn.classList.remove('checked');
                });
            }

            // Activate the question
            el.classList.add('active');
        }
        else el.classList.remove('active');
    });

    this.updateBtnVisibility();
    this.updateProgress();
};

Seksscan.prototype.prevQuestion = function () {
    this.currentQuestionIndex--;
    if (this.currentQuestionIndex < 0) this.currentQuestionIndex = 0;

    this.showActiveQuestion();
};

Seksscan.prototype.showResult = function () {
    this.startEl.classList.remove('active');
    this.questionsEl.classList.remove('active');
    this.resultEl.classList.add('active');

    this.currentPage = 'result';

    const yesScore = this.questionAnswers.filter((answer) => answer === 'yes').length;
    const otherScore = this.questionAnswers.filter((answer) => Array.isArray(answer) ? false : answer !== 'yes').length;

    const yesScorePercentage = Math.round(yesScore / this.defaultQuestionCount * 100);

    const scoreDescEl = yesScorePercentage >= 75 ? this.el.querySelector('.jsDescGood') : this.el.querySelector('.jsDescImprovement');
    const otherScoreDescEl = yesScorePercentage >= 75 ? this.el.querySelector('.jsDescImprovement') : this.el.querySelector('.jsDescGood');

    scoreDescEl.innerHTML = scoreDescEl.innerHTML.replace('#YES_COUNT#', yesScore);
    scoreDescEl.innerHTML = scoreDescEl.innerHTML.replace('#OTHER_COUNT#', otherScore);

    this.percentageEl.innerHTML = `${Math.round(yesScorePercentage)}%`;
    document.documentElement.style.setProperty('--seksscan-result-percentage', `${yesScorePercentage}%`);

    scoreDescEl.classList.add('active');
    otherScoreDescEl.classList.remove('active');

    window.dataLayer.push({ event: 'seksscan_completed', percentage: yesScorePercentage });
};

(function () {
    const seksscanEl = document.querySelector('.jsSeksscan');
    if (seksscanEl) new Seksscan(seksscanEl);
})();
